import orderBy from 'lodash/orderBy';

import {
    aggregationFieldPortfolio,
    AggregationField,
} from './aggregationFieldPortfolio';
import { CurrencyFormat } from '@instinet-analytics/core-lib';

export const aggregationFieldDropdownItems = orderBy(
    Object.keys(aggregationFieldPortfolio).map((k) => {
        const field = k as keyof typeof aggregationFieldPortfolio;
        const fieldItem = aggregationFieldPortfolio[field]!;

        return { key: field, value: field, text: fieldItem.text };
    }),
    'ordinal'
);

export const getAggregationFieldDropdownItem = (
    aggregationField: AggregationField
) => aggregationFieldDropdownItems.find((f) => f.value === aggregationField);

export const getAggregationFieldHeaderText = (
    aggregationField: AggregationField,
    currencyFormat: CurrencyFormat
): string => {
    const dropdownItem = getAggregationFieldDropdownItem(aggregationField);
    const field = aggregationFieldPortfolio[aggregationField]!;
    return field.header
        ? field.header(currencyFormat)
        : dropdownItem?.text ?? '';
};

export const getAggregationFieldText = (
    aggregationField: AggregationField
): string => {
    const dropdownItem = getAggregationFieldDropdownItem(aggregationField);
    return dropdownItem?.text ?? '';
};
